import React, { useEffect, useRef, useState } from 'react';
import { Section } from '../../common/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { ProductExtra, ProductsList } from '../';
import './MenuSection.css';

export const MenuSection = (props: { section: Section }) => {
    const [isOpen, setOpen] = useState(false);
    const [height, setHeight] = useState<number|undefined>(0);

    const toggle = () => {
        setOpen(!isOpen);
    };

    const ref = useRef<HTMLDivElement>(null);
 
    useEffect(() => {
        if (isOpen) setHeight(ref.current?.getBoundingClientRect().height);
        else setHeight(0);
    }, [isOpen]);

    return(
        <div key={ props.section.key }>
            <h2 className='menu-section-title' onClick={toggle}>
                { props.section.name }

                <i className='toggle-status'>
                {!isOpen ? (
                    <FontAwesomeIcon icon={faChevronDown} />
                ) : (
                    <FontAwesomeIcon icon={faChevronUp} />
                )}
                </i>
            </h2>
            <div className='my-collapse' style={{ height }}>
                <div ref={ ref }>
                    <ProductsList list={ props.section.products } />
                    { props.section.extras && <>
                        { props.section.extras.map((extra) => (
                            <div key={ extra.key } className="product-extra-line">
                                <ProductExtra extra={ extra } />
                            </div>
                        ))}
                    </> }
                </div>
            </div>
        </div>
    )
}
